import { Box, IconButton, Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Title = styled(Typography)<TypographyProps>(({ theme }) => ({
  marginBottom: '20px !important',
  fontSize: '2rem',
  fontWeight: 700,
  color: '#10b981', // Colore emerald per coerenza con il tema

  [theme.breakpoints.down('lg')]: {
    fontSize: '1.75rem',
    marginBottom: '16px !important',
  },

  [theme.breakpoints.down('md')]: {
    fontSize: '1.5rem',
    marginBottom: '14px !important',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '1.25rem',
    marginBottom: '12px !important',
  },

  [theme.breakpoints.down('xs')]: {
    fontSize: '1.125rem',
    marginBottom: '10px !important',
  },
}));

export const TabsWrapper = styled(Box)(({ theme }) => ({
  marginBottom: '54px',
  borderBottom: '1px solid rgba(221, 221, 234, 1)',

  '& .MuiTabs-root': {
    minHeight: '48px',
  },

  '& .MuiTab-root': {
    fontSize: '1rem',
    fontWeight: 600,
    textTransform: 'none',
    minHeight: '48px',
    padding: '12px 24px',

    [theme.breakpoints.down('md')]: {
      fontSize: '0.95rem',
      padding: '10px 20px',
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
      padding: '8px 16px',
      minHeight: '44px',
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: '0.85rem',
      padding: '6px 12px',
      minHeight: '40px',
    },
  },

  [theme.breakpoints.down('lg')]: {
    marginBottom: '44px',
  },

  [theme.breakpoints.down('md')]: {
    marginBottom: '38px',
  },

  [theme.breakpoints.down('sm')]: {
    marginBottom: '32px',
  },

  [theme.breakpoints.down('xs')]: {
    marginBottom: '28px',
  },
}));

export const TabContent = styled(Box)(({ theme }) => ({
  width: '100%',
  // Rimuovo maxWidth da qui perché ora è gestito dal ContentContainer

  '.MuiButton-contained': {
    maxWidth: '360px',
    alignSelf: 'center',
    marginTop: '10px',
    marginBottom: '40px',
    height: '48px',
    fontSize: '1rem',
    fontWeight: 600,

    [theme.breakpoints.down('md')]: {
      maxWidth: '320px',
      height: '44px',
      fontSize: '0.95rem',
      marginBottom: '32px',
    },

    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      height: '42px',
      fontSize: '0.9rem',
      marginTop: '8px',
      marginBottom: '28px',
    },

    [theme.breakpoints.down('xs')]: {
      height: '40px',
      fontSize: '0.85rem',
      marginTop: '6px',
      marginBottom: '24px',
    },
  },
}));

export const CustomFormulaWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
  paddingBottom: '10px',
  borderBottom: '1px solid rgba(221, 221, 234, 1)',
  marginTop: '32px',
  marginBottom: '16px',

  '& .MuiTypography-root': {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: '#111827',

    [theme.breakpoints.down('md')]: {
      fontSize: '1.125rem',
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: '0.95rem',
    },
  },

  [theme.breakpoints.down('md')]: {
    marginTop: '28px',
    marginBottom: '14px',
  },

  [theme.breakpoints.down('sm')]: {
    marginTop: '24px',
    marginBottom: '12px',
    gap: '4px',
  },

  [theme.breakpoints.down('xs')]: {
    marginTop: '20px',
    marginBottom: '10px',
    gap: '3px',
  },
}));

export const AddButton = styled(IconButton)(({ theme }) => ({
  '.MuiSvgIcon-root': {
    fill: 'rgba(1, 128, 148, 1)',
    fontSize: '1.5rem',

    [theme.breakpoints.down('md')]: {
      fontSize: '1.375rem',
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: '1.125rem',
    },
  },

  '&:hover .MuiSvgIcon-root': {
    fill: 'rgba(7, 87, 100, 1)',
  },

  padding: '8px',

  [theme.breakpoints.down('sm')]: {
    padding: '6px',
  },

  [theme.breakpoints.down('xs')]: {
    padding: '4px',
  },
}));

export const ChipLabelContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',

  'svg:not(:last-of-type)': {
    minWidth: '24px',
    minHeight: '24px',

    [theme.breakpoints.down('sm')]: {
      minWidth: '20px',
      minHeight: '20px',
    },

    [theme.breakpoints.down('xs')]: {
      minWidth: '18px',
      minHeight: '18px',
    },
  },

  'svg:last-of-type': {
    fill: 'rgba(34, 40, 34, 1)',
  },

  '& .MuiTypography-root': {
    fontSize: '0.875rem',

    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
    },
  },

  [theme.breakpoints.down('sm')]: {
    gap: '4px',
  },

  [theme.breakpoints.down('xs')]: {
    gap: '3px',
  },
}));

export const LoaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '15px',

  [theme.breakpoints.down('sm')]: {
    marginTop: '12px',
  },

  [theme.breakpoints.down('xs')]: {
    marginTop: '10px',
  },
}));
